import { Component,ViewChild } from '@angular/core';
import { FormGroup,FormControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { faCalendar,faEllipsisVertical,faCircleCheck,faXmark} from '@fortawesome/pro-regular-svg-icons';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {SppdashboardService} from '../view/dashboard/sppdashboard.service';

@Component({
  selector: 'app-cookie',
  standalone:true,
  imports: [OverlayModule,CdkTrapFocus,MatTabsModule,MatDialogModule,MatDatepickerModule,FontAwesomeModule,FormsModule,MatFormFieldModule,MatInputModule,ReactiveFormsModule,CommonModule],
  templateUrl: './cookie.component.html',
  styleUrls: [ './cookie.component.scss']
})
export class CookieComponent {

   constructor(
      public dialogRef: MatDialogRef<CookieComponent>, private _fb: FormBuilder,private sppdashboardService:SppdashboardService
    ) { }
  public dialogForm = new FormGroup({
    searchValue: new FormControl(''),
    name: new FormControl('',Validators.required),
    address1:new FormControl('',Validators.required),
    address2:new FormControl('',Validators.required),
    birthdate:new FormControl('',Validators.required)
  });

  submitPrivacyForm(){
    sessionStorage.setItem('privacy','true');
    this.dialogRef.close()
  }

  submitForm(){
    sessionStorage.setItem('cookie','true');
    const formData = new FormData();
    formData.set('impTerms', sessionStorage.getItem('cookie')||'');
    formData.set('privacy', sessionStorage.getItem('privacy')||'');
    this.sppdashboardService.termsprivacy(formData).subscribe((response:any)=>{})
    window.location.reload();
    this.dialogRef.close();
  }
}
